module.exports = __webpack_public_path__ + "img/bd_other04.5fda9470.png";